import React, { useState } from 'react';

const EmailUserModal = ({ show, onClose, onSend, user }) => {
  const [formData, setFormData] = useState({ subject: '', message: '' });
  const [loading, setLoading] = useState(false);

  if (!show || !user) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const success = await onSend(user.id, formData);
    setLoading(false);
    if (success) {
      setFormData({ subject: '', message: '' });
      onClose();
    }
  };

  return (
    <div className="modal fade show block bg-[rgba(0,0,0,0.5)]">
      <div className="modal-dialog">
        <div className="modal-content border-0 shadow">
          <div className="modal-header border-0 pb-0">
            <h5 className="modal-title fw-bold">Send Email</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p className="text-muted small mb-3">
              Sending to: <strong>{user.email}</strong>
            </p>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label text-muted small fw-bold">Subject</label>
                <input
                  type="text"
                  className="form-control"
                  required
                  value={formData.subject}
                  onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                />
              </div>
              <div className="mb-4">
                <label className="form-label text-muted small fw-bold">Message</label>
                <textarea
                  className="form-control"
                  rows="4"
                  required
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                ></textarea>
              </div>
              <div className="d-grid">
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Sending...
                    </>
                  ) : (
                    'Send Message'
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailUserModal;
